<template>
	<div class="custom-historico" v-show='getShowTickets'>
		<div class="container-fluid">
			<div class="row mt-2 mb-2">
				<div class="col-md-12">
					<h2 class="text-center">Gerenciamento de Tickets</h2>
				</div>
			</div>
		</div>

		<TicketsManager :onlyOpen="true" :hasAlert="true" :hasInterval="getShowTickets"></TicketsManager>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import TicketsManager from './manager/TicketsManager.vue';

export default {
	name: "TicketsPage",
	components: {
		TicketsManager
	},
	computed: {
		...mapGetters(['getShowTickets'])
	},
}
</script>

<style>
.check {
	margin-top: 2.6em;
	margin-left: 1em;
}

.custom-historico {
	display: flex;
	flex-direction: column;
	padding: 0.4rem 2rem 2rem;
}

.show-plus {
	display: flex;
	align-items: center;
	justify-content: center;
}

.tables th,
.tables td {
	border: none;
}

.tables tr:nth-child(even) {
	background-color: rgba(0, 0, 0, 0.05);
}

.tables th {
	background-color: #1c869a;
	color: white;
	padding: 8px;
	border: groove 1px lightgray
}
</style>
